import React from "react";
import { array, func, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import LoadMore from "../../atoms/loadmore";
import CustomStoryCard6 from "../../molecules/custom-story-card6";

import translate from "../../translate";

import "./storyList.m.css";

const StoryList = ({ list, onLoadMoreClick, isMoreStories, publisherName }) => {
  if (!list.length) {
    return null;
  }

  return (
    <div styleName="wrapper">
      <ul styleName="stories">
        {list.map((item, index) => (
          <li key={index}>
            <CustomStoryCard6
              story={item}
              key={index}
              aspectRatio={[16, 9]}
              imageType="image16x9"
              widths={[150]}
              className={isMoreStories && index + 1 === list.length ? "custom-story-card-6" : ""}
            />
          </li>
        ))}
      </ul>

      {isMoreStories && onLoadMoreClick && (
        <LoadMore onClick={onLoadMoreClick} content={translate(publisherName, "load_more")} />
      )}
    </div>
  );
};

StoryList.propTypes = {
  list: array,
  isMoreStories: string,
  onLoadMoreClick: func,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(StoryList);
